<template>

    <div>
        <div class="row margin-bottom">
            <div class="col-sm-8">
                <h3 style="margin-top:0;">Geregistreerde vakantieuren {{ year }}</h3>
            </div>
            <div class="col-sm-4 text-right">
                <div class="btn-group btn-group-xs">
                    <button
                        class="btn btn-default"
                        type="button"
                        :disabled="!canGoToPrevYear"
                        @click="prevYear()"
                    >
                        <i class="fa fa-chevron-left"></i>
                    </button>
                    <button
                        class="btn btn-default"
                        type="button"
                    >
                        {{ year }}
                    </button>
                    <button
                        class="btn btn-default"
                        :disabled="!canGoToNextYear"
                        type="button"
                        @click="nextYear()"
                    >
                        <i class="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Datum</th>
                        <th>Kostcode</th>
                        <th>Aantal uren</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="registered.length === 0"><td colspan="3">Er zijn geen geregistreerde vakantieuren gevonden</td></tr>
                    <tr
                        v-for="item in registered"
                    >
                        <td>{{ moment(item.date).format('DD-MM-YYYY') }}</td>
                        <td>{{ item.costcode }}</td>
                        <td>{{ item.hours }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>

import moment from "moment";
import axios from 'axios';

export default {

    computed: {
        canGoToNextYear() {
            return this.loading === false &&
                (this.year + 1) <= parseInt(moment().format("YYYY"));
        },
        canGoToPrevYear() {
            return this.loading === false;
        },
    },

    data() {
        return {
            loading:true,
            moment:moment,
            registered:[],
            year:2020,
        }
    },

    methods: {
        getRegisteredHours() {
            axios.get(this.url, {params: {year:this.year}})
                .then(resp => this.registered = resp.data.data)
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de ingeplande vakantieuren'))
                .finally(() => this.loading = false);
        },
        prevYear() {
            this.year--;
            this.load();
        },
        nextYear() {
            this.year++;
            this.load();
        },
        load() {
            this.loading = true;
            this.getRegisteredHours();
        }
    },

    mounted(){
        this.year = parseInt(moment().format("YYYY"));
        this.load();
    },

    name:'HrVacationHoursRegistered',

    props: {
        url: {
            required:true,
            type:String,
        },
    },

}

</script>
